import React, { useState } from 'react';
import { UserIcon, BuildingIcon, PhoneIcon, MailIcon, MapPinIcon, GlobeIcon, EditIcon } from 'lucide-react';
export function Profile() {
  // Mock user data - in a real app, this would come from an API
  const [user, setUser] = useState({
    name: 'John Doe',
    role: 'buyer',
    email: 'john.doe@example.com',
    phone: '+1 (555) 123-4567',
    company: 'ABC Manufacturing',
    position: 'Procurement Manager',
    address: '123 Business Ave, Suite 100, New York, NY 10001',
    website: 'www.abcmanufacturing.com',
    bio: 'Experienced procurement manager with 10+ years in the manufacturing industry. Specializing in packaging materials and supply chain optimization.',
    preferences: {
      emailNotifications: true,
      orderUpdates: true,
      newSupplierAlerts: true,
      promotionalEmails: false,
      twoFactorAuth: true
    }
  });
  // Mock orders data
  const orders = [{
    id: 'ORD-12345',
    date: 'Jun 12, 2023',
    supplier: 'BoxMaster Inc.',
    status: 'Delivered',
    total: '$1,250.00'
  }, {
    id: 'ORD-12346',
    date: 'May 28, 2023',
    supplier: 'Green Packaging Co.',
    status: 'Shipped',
    total: '$875.50'
  }, {
    id: 'ORD-12347',
    date: 'May 15, 2023',
    supplier: 'BrandPack Solutions',
    status: 'Processing',
    total: '$2,340.00'
  }, {
    id: 'ORD-12348',
    date: 'Apr 30, 2023',
    supplier: 'SafePack Inc.',
    status: 'Delivered',
    total: '$560.25'
  }];
  // State for active tab
  const [activeTab, setActiveTab] = useState('profile');
  return <div className="space-y-6" data-id="element-733">
      {/* Profile Header */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-734">
        <div className="bg-blue-600 h-32" data-id="element-735"></div>
        <div className="px-6 py-4 flex flex-col sm:flex-row sm:items-end -mt-16" data-id="element-736">
          <div className="h-24 w-24 rounded-full bg-white p-1 shadow-lg" data-id="element-737">
            <div className="h-full w-full rounded-full bg-blue-100 flex items-center justify-center" data-id="element-738">
              <span className="text-3xl font-bold text-blue-600" data-id="element-739">
                {user.name.charAt(0)}
              </span>
            </div>
          </div>
          <div className="mt-6 sm:mt-0 sm:ml-6 flex-1" data-id="element-740">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between" data-id="element-741">
              <div data-id="element-742">
                <h1 className="text-2xl font-bold text-gray-900" data-id="element-743">
                  {user.name}
                </h1>
                <p className="text-gray-500 capitalize" data-id="element-744">{user.role}</p>
              </div>
              <div className="mt-4 sm:mt-0" data-id="element-745">
                <button className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center" data-id="element-746">
                  <EditIcon className="h-4 w-4 mr-2" data-id="element-747" />
                  Edit Profile
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200" data-id="element-748">
          <nav className="flex overflow-x-auto" aria-label="Tabs" data-id="element-749">
            <button onClick={() => setActiveTab('profile')} className={`${activeTab === 'profile' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm`} data-id="element-750">
              Profile
            </button>
            <button onClick={() => setActiveTab('orders')} className={`${activeTab === 'orders' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm`} data-id="element-751">
              Orders
            </button>
            <button onClick={() => setActiveTab('preferences')} className={`${activeTab === 'preferences' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm`} data-id="element-752">
              Preferences
            </button>
            <button onClick={() => setActiveTab('security')} className={`${activeTab === 'security' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'} whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm`} data-id="element-753">
              Security
            </button>
          </nav>
        </div>
      </div>
      {/* Profile Content */}
      {activeTab === 'profile' && <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-754">
          <div className="px-6 py-5 border-b border-gray-200" data-id="element-755">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-756">
              Profile Information
            </h3>
          </div>
          <div className="px-6 py-5" data-id="element-757">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-758">
              <div className="space-y-6" data-id="element-759">
                <div data-id="element-760">
                  <h4 className="text-sm font-medium text-gray-500" data-id="element-761">
                    Personal Information
                  </h4>
                  <div className="mt-2 space-y-4" data-id="element-762">
                    <div className="flex items-center" data-id="element-763">
                      <UserIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-764" />
                      <span className="text-gray-900" data-id="element-765">{user.name}</span>
                    </div>
                    <div className="flex items-center" data-id="element-766">
                      <MailIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-767" />
                      <span className="text-gray-900" data-id="element-768">{user.email}</span>
                    </div>
                    <div className="flex items-center" data-id="element-769">
                      <PhoneIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-770" />
                      <span className="text-gray-900" data-id="element-771">{user.phone}</span>
                    </div>
                  </div>
                </div>
                <div data-id="element-772">
                  <h4 className="text-sm font-medium text-gray-500" data-id="element-773">
                    Company Information
                  </h4>
                  <div className="mt-2 space-y-4" data-id="element-774">
                    <div className="flex items-center" data-id="element-775">
                      <BuildingIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-776" />
                      <span className="text-gray-900" data-id="element-777">{user.company}</span>
                    </div>
                    <div className="flex items-center" data-id="element-778">
                      <UserIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-779" />
                      <span className="text-gray-900" data-id="element-780">{user.position}</span>
                    </div>
                    <div className="flex items-start" data-id="element-781">
                      <MapPinIcon className="h-5 w-5 text-gray-400 mr-2 mt-0.5" data-id="element-782" />
                      <span className="text-gray-900" data-id="element-783">{user.address}</span>
                    </div>
                    <div className="flex items-center" data-id="element-784">
                      <GlobeIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-785" />
                      <span className="text-gray-900" data-id="element-786">{user.website}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-787">
                <h4 className="text-sm font-medium text-gray-500" data-id="element-788">Bio</h4>
                <p className="mt-2 text-gray-900" data-id="element-789">{user.bio}</p>
              </div>
            </div>
          </div>
        </div>}
      {/* Orders Tab */}
      {activeTab === 'orders' && <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-790">
          <div className="px-6 py-5 border-b border-gray-200" data-id="element-791">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-792">Order History</h3>
          </div>
          <div className="overflow-x-auto" data-id="element-793">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-794">
              <thead className="bg-gray-50" data-id="element-795">
                <tr data-id="element-796">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-797">
                    Order ID
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-798">
                    Date
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-799">
                    Supplier
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-800">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-801">
                    Total
                  </th>
                  <th scope="col" className="relative px-6 py-3" data-id="element-802">
                    <span className="sr-only" data-id="element-803">View</span>
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-804">
                {orders.map(order => <tr key={order.id} data-id="element-805">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-806">
                      {order.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-807">
                      {order.date}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-808">
                      {order.supplier}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-809">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${order.status === 'Delivered' ? 'bg-green-100 text-green-800' : order.status === 'Shipped' ? 'bg-blue-100 text-blue-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-810">
                        {order.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-811">
                      {order.total}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-812">
                      <a href="#" className="text-blue-600 hover:text-blue-900" data-id="element-813">
                        View
                      </a>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="px-6 py-4 border-t border-gray-200" data-id="element-814">
            <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-815">
              View all orders
            </a>
          </div>
        </div>}
      {/* Preferences Tab */}
      {activeTab === 'preferences' && <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-816">
          <div className="px-6 py-5 border-b border-gray-200" data-id="element-817">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-818">
              Notification Preferences
            </h3>
          </div>
          <div className="px-6 py-5 space-y-6" data-id="element-819">
            <div className="flex items-center justify-between" data-id="element-820">
              <div data-id="element-821">
                <h4 className="text-sm font-medium text-gray-900" data-id="element-822">
                  Email Notifications
                </h4>
                <p className="text-sm text-gray-500" data-id="element-823">
                  Receive emails about your account activity
                </p>
              </div>
              <div className="flex items-center" data-id="element-824">
                <input id="email-notifications" name="email-notifications" type="checkbox" checked={user.preferences.emailNotifications} onChange={() => setUser({
              ...user,
              preferences: {
                ...user.preferences,
                emailNotifications: !user.preferences.emailNotifications
              }
            })} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-825" />
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-826">
              <div data-id="element-827">
                <h4 className="text-sm font-medium text-gray-900" data-id="element-828">
                  Order Updates
                </h4>
                <p className="text-sm text-gray-500" data-id="element-829">
                  Receive notifications about your order status
                </p>
              </div>
              <div className="flex items-center" data-id="element-830">
                <input id="order-updates" name="order-updates" type="checkbox" checked={user.preferences.orderUpdates} onChange={() => setUser({
              ...user,
              preferences: {
                ...user.preferences,
                orderUpdates: !user.preferences.orderUpdates
              }
            })} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-831" />
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-832">
              <div data-id="element-833">
                <h4 className="text-sm font-medium text-gray-900" data-id="element-834">
                  New Supplier Alerts
                </h4>
                <p className="text-sm text-gray-500" data-id="element-835">
                  Get notified when new suppliers join the platform
                </p>
              </div>
              <div className="flex items-center" data-id="element-836">
                <input id="supplier-alerts" name="supplier-alerts" type="checkbox" checked={user.preferences.newSupplierAlerts} onChange={() => setUser({
              ...user,
              preferences: {
                ...user.preferences,
                newSupplierAlerts: !user.preferences.newSupplierAlerts
              }
            })} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-837" />
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-838">
              <div data-id="element-839">
                <h4 className="text-sm font-medium text-gray-900" data-id="element-840">
                  Promotional Emails
                </h4>
                <p className="text-sm text-gray-500" data-id="element-841">
                  Receive emails about promotions and special offers
                </p>
              </div>
              <div className="flex items-center" data-id="element-842">
                <input id="promotional-emails" name="promotional-emails" type="checkbox" checked={user.preferences.promotionalEmails} onChange={() => setUser({
              ...user,
              preferences: {
                ...user.preferences,
                promotionalEmails: !user.preferences.promotionalEmails
              }
            })} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-843" />
              </div>
            </div>
          </div>
          <div className="px-6 py-5 border-t border-gray-200 flex justify-end" data-id="element-844">
            <button className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-845">
              Save Preferences
            </button>
          </div>
        </div>}
      {/* Security Tab */}
      {activeTab === 'security' && <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-846">
          <div className="px-6 py-5 border-b border-gray-200" data-id="element-847">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-848">
              Security Settings
            </h3>
          </div>
          <div className="px-6 py-5 space-y-6" data-id="element-849">
            <div data-id="element-850">
              <h4 className="text-sm font-medium text-gray-900" data-id="element-851">
                Change Password
              </h4>
              <div className="mt-4 space-y-4" data-id="element-852">
                <div data-id="element-853">
                  <label htmlFor="current-password" className="block text-sm font-medium text-gray-700" data-id="element-854">
                    Current Password
                  </label>
                  <input type="password" name="current-password" id="current-password" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-855" />
                </div>
                <div data-id="element-856">
                  <label htmlFor="new-password" className="block text-sm font-medium text-gray-700" data-id="element-857">
                    New Password
                  </label>
                  <input type="password" name="new-password" id="new-password" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-858" />
                </div>
                <div data-id="element-859">
                  <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700" data-id="element-860">
                    Confirm New Password
                  </label>
                  <input type="password" name="confirm-password" id="confirm-password" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-861" />
                </div>
              </div>
              <div className="mt-4" data-id="element-862">
                <button className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-863">
                  Update Password
                </button>
              </div>
            </div>
            <div className="pt-6 border-t border-gray-200" data-id="element-864">
              <div className="flex items-center justify-between" data-id="element-865">
                <div data-id="element-866">
                  <h4 className="text-sm font-medium text-gray-900" data-id="element-867">
                    Two-Factor Authentication
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-868">
                    Add an extra layer of security to your account
                  </p>
                </div>
                <div className="flex items-center" data-id="element-869">
                  <input id="two-factor" name="two-factor" type="checkbox" checked={user.preferences.twoFactorAuth} onChange={() => setUser({
                ...user,
                preferences: {
                  ...user.preferences,
                  twoFactorAuth: !user.preferences.twoFactorAuth
                }
              })} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-870" />
                </div>
              </div>
            </div>
            <div className="pt-6 border-t border-gray-200" data-id="element-871">
              <h4 className="text-sm font-medium text-gray-900" data-id="element-872">Sessions</h4>
              <p className="text-sm text-gray-500" data-id="element-873">
                Manage your active sessions across devices
              </p>
              <div className="mt-4 space-y-4" data-id="element-874">
                <div className="flex items-center justify-between" data-id="element-875">
                  <div data-id="element-876">
                    <p className="text-sm font-medium text-gray-900" data-id="element-877">
                      Current Session
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-878">
                      Chrome on Windows • New York, USA • Last active just now
                    </p>
                  </div>
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-879">
                    Active
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-880">
                  <div data-id="element-881">
                    <p className="text-sm font-medium text-gray-900" data-id="element-882">
                      Mobile App
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-883">
                      iOS • New York, USA • Last active 2 hours ago
                    </p>
                  </div>
                  <button className="text-sm text-red-600 hover:text-red-500" data-id="element-884">
                    End Session
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}